import React from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  MenuItem,
  Select,
  TextField,
  IconButton,
  Typography
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import _ from "lodash";

import useStyles from "../style";

const numbers = `0123456789`;

const SelectLabelInputStepper = ({
  id,
  selectLabel,
  selectValue,
  selectOptions,
  value,
  min,
  max,
  onSelectChange,
  onChange
}) => {
  const classes = useStyles();

  const onStepperSelectChange = evt => {
    onSelectChange(evt.target.value);
  };

  const onMinusClick = () => {
    onChange(Math.max(value - 1, min));
  };

  const onPlusClick = () => {
    onChange(Math.min(value + 1, max));
  };

  const onKeyPress = evt => {
    if (`-` === evt.key && min < 0) onChange(Math.max(-value, min));
    if (!_.includes(numbers, evt.key)) evt.preventDefault();
  };

  const onTextChange = evt => {
    _.chain(evt.target.value)
      .toInteger()
      .thru(val => Math.max(val, min))
      .thru(val => Math.min(val, max))
      .thru(val => onChange(val))
      .commit();
  };

  return (
    <div className={classes.inputStepper}>
      <FormControl className={classes.inputStepperSelectFormControl}>
        <Typography variant="srOnly" id={`${id}_label`}>
          {selectLabel}
        </Typography>
        <Select
          className={classes.inputStepperSelectLabel}
          labelId={`${id}_label`}
          id={id}
          variant="outlined"
          value={selectValue}
          onChange={onStepperSelectChange}
        >
          {_.map(selectOptions, option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <IconButton
        aria-label={`subtract one ${value}`}
        className={classes.inputStepperIcon}
        onClick={onMinusClick}
      >
        <RemoveIcon />
      </IconButton>
      <TextField
        label={`${min} to ${max}`}
        id={`${id}_input_stepper_text`}
        variant="outlined"
        value={_.toString(value)}
        className={classes.inputStepperSelectTextField}
        onKeyPress={onKeyPress}
        onChange={onTextChange}
      />
      <IconButton
        aria-label={`add one ${value}`}
        className={classes.inputStepperIcon}
        onClick={onPlusClick}
      >
        <AddIcon />
      </IconButton>
    </div>
  );
};

SelectLabelInputStepper.defaultProps = {
  id: `default_input_stepper`,
  selectLabel: `default_input_stepper aria label`,
  selectValue: `Please supply selectValue`,
  selectOptions: [`Please supply selectValue`, `Please supply selectOptions`],
  value: 0,
  min: 0,
  max: 10,
  onSelectChange: () => {
    console.log(`Please pass in an onSelectChange function`);
  },
  onChange: () => {
    console.log(`Please pass in an onChange function`);
  }
};

const requireInteger = (props, propName, componentName) =>
  _.isInteger(props[propName])
    ? undefined
    : new Error(`${componentName} warning: ${propName} must be an integer`);

const constrain = (props, propName, componentName) =>
  _.isInteger(props[propName]) &&
  props[propName] >= props.min &&
  props[propName] <= props.max
    ? undefined
    : new Error(
        `${componentName} warning: ${propName} must be an integer between the min and max props`
      );

const inSelectOptions = (props, propName, componentName) =>
  _.includes(props.selectOptions, props[propName])
    ? undefined
    : new Error(
        `${componentName} warning: ${propName} must be included in selectOptions`
      );

SelectLabelInputStepper.propTypes = {
  id: PropTypes.string,
  selectLabel: PropTypes.string,
  selectValue: inSelectOptions,
  selectOptions: PropTypes.arrayOf(PropTypes.string),
  value: constrain,
  min: requireInteger,
  max: requireInteger,
  onSelectChange: PropTypes.func,
  onChange: PropTypes.func
};

export default SelectLabelInputStepper;
